import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { Figure } from "./styles";

const StyledImage = styled.img`
    /* Add any default styles here if needed */
`;

const ImageContent = ({
    image,
    imageAlt,
    imageCaption,
    imageLink,
    ...imageProps
}) => {
    const imageEl = (
        <StyledImage
            src={image}
            alt={imageAlt}
            title={imageAlt}
            {...imageProps}
        />
    );
    const imageElWithLink = <a href={imageLink}>{imageEl}</a>;

    return (
        <Figure>
            {imageLink ? imageElWithLink : imageEl}
            {imageCaption && <figcaption>{imageCaption}</figcaption>}
        </Figure>
    );
};

ImageContent.propTypes = {
    image: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    imageCaption: PropTypes.string,
    imageAlt: PropTypes.string.isRequired,
    imageLink: PropTypes.string
};

export default ImageContent;
